import customAxios from "./axiosConfig";

const QuotationService = {
  list (params) {
    const api_url = window.Urls['quotation-list']()
    return customAxios.get(api_url, { params: params })
  },
  create (data) {
    const api_url = window.Urls['quotation-list']();
    return customAxios.post(api_url, data);
  },
  retrieve (pk, params) {
    const api_url = window.Urls['quotation_detail'](pk);
    return customAxios.get(api_url, { params: params });
  },
  update (pk, data) {
    const api_url = window.Urls['quotation-detail'](pk);
    return customAxios.put(api_url, data);
  },
  destroy (pk) {
    const api_url = window.Urls['quotation_detail'](pk);
    return customAxios.delete(api_url);
  },
  toInvoice(pk){
    const api_url = window.Urls["quotation_to_invoice"](pk)
    return customAxios.get(api_url);
  },
  changeStatus(pk, data, notify = false) {
    let api_url = window.Urls['quotation_change_status'](pk);
    if (!notify) {
      api_url = api_url + '?skip_email_sending=true'
    }
    return customAxios.put(api_url, data);
  },
  totalAmounts (params) {
    const api_url = window.Urls['quotation_totals']()
    return customAxios.get(api_url, { params: params })
  },
  customerList (params) {
    const api_url = window.Urls['quotation_customer_list']();
    return customAxios.get(api_url, { params: params });
  },
  send (details) {
    const api_url = window.Urls['quotation-send'](details.id);
    return customAxios.post(api_url, details);
  },
  // PUBLIC 
  retrieveQuotationPublic (uuid, params) {
    const api_url = window.Urls['quotation_get_by_uuid'](uuid)
    return customAxios.get(api_url, { params: params })
  },
  acceptQuotationPublic (uuid, params) {
    const api_url = window.Urls['quotation_accept_quotation'](uuid)
    return customAxios.get(api_url, { params: params })
  },
  rejectQuotationPublic (uuid, params) {
    const api_url = window.Urls['quotation_reject_quotation'](uuid)
    return customAxios.get(api_url, { params: params })
  },
  getNextQuotationNumber(data){
    var api_url = window.Urls['quotation-next-quotation-number']();
    return customAxios.post(api_url, data);
  },
  getQuotationPDFBlob (uuid) {
    const api_url = window.Urls['quotation_download_pdf'](uuid)
    return customAxios.get(api_url, { responseType: 'blob' }).then((response) => {
      return response.data
    })
  }
}

export default QuotationService;
